import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { isRouteErrorResponse, Link, useRouteError } from "react-router";
import { PageHelmet } from "@/src/common/components/page-helmet";
import { Button } from "@/src/common/components/ui";

export function ErrorRouteBoundary() {
	const { t } = useTranslation();
	const error = useRouteError();

	const isNotFound = isRouteErrorResponse(error) && error.status === 404;
	const title = isNotFound ? t("error.route.not_found_title") : t("error.route.title");
	const description = isNotFound ? t("error.route.not_found_description") : t("error.route.description");

	if (import.meta.env.DEV) {
		console.error("ErrorRouteBoundary caught error:", error);
	}

	const handleRetry = () => {
		window.location.reload();
	};

	return (
		<>
			<PageHelmet title={title} />
			<div className="flex min-h-screen items-center justify-center bg-background px-6">
				<div className="flex max-w-md flex-col items-center text-center">
					<div className="flex size-14 items-center justify-center rounded-full bg-danger/10">
						<AlertTriangle className="size-6 text-danger" />
					</div>
					<h1 className="mt-4 text-2xl font-semibold text-foreground">{title}</h1>
					<p className="mt-2 text-balance text-foreground/50">{description}</p>
					<div className="mt-8 flex gap-3">
						<Button variant="outline" onPress={handleRetry}>
							{t("error.route.retry")}
						</Button>
						<Link to="/">
							<Button variant="primary">{t("error.route.go_home")}</Button>
						</Link>
					</div>
				</div>
			</div>
		</>
	);
}
